/**
 * TODO temperory hack. This is to be moved to PapJs and this merging should be handled by schema desgin and prime mappers
 */
export function mergeProductStrings(infoOmnitureData: any, offersOmnitureData: any) {
  if (
    infoOmnitureData.adobeMappedData &&
    infoOmnitureData.adobeMappedData.products &&
    offersOmnitureData.omnitureProperties &&
    offersOmnitureData.omnitureProperties.adobeMappedData &&
    offersOmnitureData.omnitureProperties.adobeMappedData.products
  ) {
    const rooms = offersOmnitureData.omnitureProperties.adobeMappedData.products.split('&');
    const hotel = infoOmnitureData.adobeMappedData.products;
    infoOmnitureData.adobeMappedData.products = rooms.map(room => `${hotel}${room}`).join(',');
    offersOmnitureData.omnitureProperties.adobeMappedData.products = '';
  }
}
